import React from "react";
import "../../css/MedOrg.css";
import Image from "../../assets/medorg_dashboard.png";

export default function MedOrg() {
  return (
    <section className="medorg-container">
      <div className="medorg-content">
        <h1 className="medorg-title">MedOrg</h1>
        <p className="medorg-description">
          MedOrg is a cutting-edge medical organization management platform designed
          to streamline hospital workflows, patient records, and healthcare operations.
        </p>
        <div className="medorg-actions">
          <a href="https://inquizene.com/download/medorg" download>
            <button className="medorg-btn primary">Download</button>
          </a>
          {/* <button className="medorg-btn secondary">Learn More</button> */}
        </div>
      </div>
      <div className="medorg-image">
        <img src={Image} alt="MedOrg Dashboard" />
      </div>
    </section>
  );
}
